import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  align?: 'left' | 'center';
  light?: boolean;
}
export function SectionHeading({
  title,
  subtitle,
  align = 'center',
  light = false
}: SectionHeadingProps) {
  return <div className={`mb-12 ${align === 'center' ? 'text-center' : 'text-left'}`} data-id="element-267">
      <motion.h2 className={`text-3xl md:text-4xl lg:text-5xl font-bold mb-4 text-balance ${light ? 'text-white' : 'text-dark'}`} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} data-id="element-268">
        {title}
      </motion.h2>
      {subtitle && <motion.p className={`text-lg md:text-xl max-w-2xl ${align === 'center' ? 'mx-auto' : ''} ${light ? 'text-rose-100' : 'text-dark-light'}`} initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5,
      delay: 0.1
    }} data-id="element-269">
          {subtitle}
        </motion.p>}
    </div>;
}